import { render, staticRenderFns } from "./BodyPresetGrid.vue?vue&type=template&id=2c20480c&scoped=true"
import script from "./BodyPresetGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./BodyPresetGrid.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BodyPresetGrid.vue?vue&type=style&index=0&id=2c20480c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20480c",
  null
  
)

export default component.exports